// @flow

import {Navigate, useLocation} from 'react-router-dom';

type Props = {
  path: string,
};

export const Checkout = ({path}: Props): Navigate => {
  const {search} = useLocation();
  return (
    <Navigate
      to={{
        pathname: `${path}`,
        search,
      }}
      replace
    />
  );
};
